<div class="page-not-found-wrapper">
  <div class="icon-wrapper">
    <at-icon>error</at-icon>
  </div>

  <div class="content">
    <h1 class="content-title">This page doesn't exist</h1>

    <div class="content-actions">
      @for (link of links(); track link.url) {
        <a atButton class="content-link link" size="sm" variant="tertiary" [routerLink]="link.url">
          {{ link.label }}
        </a>
      }
    </div>
  </div>
</div>
